const subUsersEN = {
    "view": {
        "table": {
            "title": "Your sub-users list",
            "column": {
                "username": "Username",
                "email": "Email",
                "first_name": "First Name",
                "last_name": "Last Name",
                "company": "Company",
                "sub_user_deal": "Deal (%)",
                "contract_expiry": "Contract Expiry",
                "is_active": "Active",
                "action": "Action"
            },
            "button": {
                "edit": "Edit",
                "export_csv": "Export CSV"               
            },
            "placeholder": {
                "search": "Search..."
            },
            "label": {
                "yes": "Yes",
                "no": "No"
            },
            "dropdown": {
                "action": "Action",
                "edit": "Edit",
                "activate": "Activate",
                "deactivate": "Deactivate"
            }
        },
        "message": {
            "successUpdated": "Sub-user account has been updated!",
            "successActivated": "Sub-user account has been activated!",
            "successDeactivated": "Sub-user account has been de-activated!",
            "error": "Something went wrong! Please refresh page and try again!",
            "premiumUsersOnly": "This feature is offered to Premium Users only. Please contact support team if you want to upgrade your account.",
            "noAccess": "You don't have access to this module, please contact the support team for further information."
        },
        "modal": {
            "activateSubuser": {
                "header": "Activate Sub-user",
                "body": "Are you sure that you want to Activate Sub-User {{username}}?"
            },
            "deactivateSubuser": {
                "header": "De-Activate Sub-user",
                "body": "Are you sure that you want to De-Activate Sub-User {{username}}?"
            },
            "button": {
                "cancel": "Cancel",
                "edit": "Edit",
                "activate": "Activate",
                "deactivate": "Deactivate"
            }
        }
    },
    "add": {
        "title": "Add Sub-user",
        "form": {
            "label": {
                "personalDetails": "Personal Details",
                "firstName": "First Name",
                "lastName": "Last Name",
                "email": "Email",
                "username": "Username",
                "password": "Password",
                "confirmPassword": "Confirm Password",
                "businessDetails": "Business Details",
                "companyName": "Company Name",
                "contractExpiry": "Contract Expiry",
                "subUserDeal": "Subuser Deal (%)",
                "nationalTaxNumber": "National Tax Number",
                "businessRegistrationNumber": "Business Registration Number",
                "contactDetails": "Contact Details",
                "streetAndNumber": "Street and house number",
                "postalCode": "Postal Code",
                "city": "City",
                "country": "Country",
                "phoneNumber": "Phone Number"
            },
            "help_text": {
                "contractExpiry": "Note: Contract Expiry date cannot be set earlier than {{afterOneYear}}."
            },
            "button": {
                "submit": "Submit"
            }
        },
        "message": {
            "success": "Sub-User has been added!",
            "error": "Something went wrong! Please refresh page and try again!"
        },
        "modal": {
            "header": "Add Sub-User",
            "body": "Are you sure that you want to create a new sub-user?"
        }
    },
    "update": {
        "title": "Edit Sub-user",
        "form": {
            "label": {
                "personalDetails": "Personal Details",
                "firstName": "First Name",
                "lastName": "Last Name",
                "email": "Email",
                "username": "Username",
                "password": "Password",
                "confirmPassword": "Confirm Password",
                "businessDetails": "Business Details",
                "companyName": "Company Name",
                "contractExpiry": "Contract Expiry",
                "subUserDeal": "Subuser Deal (%)",
                "nationalTaxNumber": "National Tax Number",
                "businessRegistrationNumber": "Business Registration Number",
                "contactDetails": "Contact Details",
                "streetAndNumber": "Street and house number",
                "postalCode": "Postal Code",
                "city": "City",
                "country": "Country",
                "phoneNumber": "Phone Number"
            },
            "help_text": {
                "contractExpiry": "Note: Contract Expiry date cannot be set earlier than {{afterOneYear}}."
            },
            "button": {
                "submit": "Submit"
            }
        },
        "message": {
            "success": "Sub-User has been updated!",
            "error": "Something went wrong! Please refresh page and try again!"
        },
    }
};

export default subUsersEN;